import API from '../../lib/api'

const api = new API(1, 'account')

const state = {
	user: null,
	tenant: null
}

const getters = {
	user: state => {
		return state.tenant
	},
	tenant: state => {
		return state.tenant
	}
}

const actions = {
	get: (context) => {
		return new Promise((resolve, reject) => {
			if(context.state.user && context.state.tenant) {
				resolve({ user: context.state.user, tenant: context.state.tenant })
				return
			}

			api.get().then(res => {
				context.commit('set', res)
				resolve(res)
			})
			.catch(err => {
				reject(err)
			})
		})
	},
	update: (context, obj) => {
		return new Promise((resolve, reject) => {
			return api.put('', { user: obj.user, tenant: obj.tenant }).then(res => {
				resolve(res)
				context.commit('set', { user: obj.user, tenant: obj.tenant })
			})
			.catch(err => {
				reject(err)
			})
		})
	},
	flush: (context) => {
		context.commit('set', { user: null, tenant: null })
	}
}

const mutations = {
	set: (state, res) => {
		state.user = res.user
		state.tenant = res.tenant
	}
}

export default {
	namespaced: true,
	state: state,
	getters: getters,
	actions: actions,
	mutations: mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/account.js